<template>
<!--  v-if="contactData" -->
  <div class="contact-box" v-if="false">
    <div class="contact" @click="visible = !visible">
      <img src="@assets/img/exhibition/contact.png" alt="联系我们" />
      <span>联系我们</span>
    </div>
    <div class="msgbox clear ng-star-inserted" v-if="visible">
      <div class="main">
        <div class="title">
          <h2>您的专属客服：吴美涓</h2>
        </div>
        <p class="time">服务时间（9:00-20:00）</p>
        <p class="phone">
          <i class="icon iconfont icon-dianhua2"></i>13564634849
        </p>
        <div class="btn">
          <i class="icon iconfont icon-qq"></i>
          QQ咨询
        </div>
        <div class="qr-code">
          <div class="serve-code ng-star-inserted">
            <img
              alt="二维码"
              src="https://exshow.oss-cn-shanghai.aliyuncs.com/exshow/imgs/201909/2ee63a0fc82b4976ba61ff02aa760ad1.jpeg"
            />
            <span>客服微信</span>
          </div>
        </div>
      </div>
    </div>
    <div class="msgbox-mask" @click.stop="visible = false" v-if="visible"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "Contact",
  data() {
    return {
      visible: false,
      contactData: null,
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    })
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getStaff: "getStaff"
    }),
    async init() {  
      if (!this.company) return;
      this.contactData = await this.getStaff(this.company.id); 
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-box {
  position: fixed;
  right: 21px;
  bottom: 21px;
  z-index: 1001;
}
.msgbox-mask {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1002;
}
.contact {
  position: fixed;
  right: 21px;
  bottom: 21px;
  width: 60px;
  height: 60px;
  background-color: #4f65ae;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
  img {
    width: 21px;
    height: 21px;
    margin-top: 10px;
  }
  span {
    font-size: 12px;
    font-family: "Microsoft YaHei";
    color: #fff;
  }
}

.msgbox {
  z-index: 1003;
  width: 250px;
  height: 310px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.2);
  position: fixed;
  bottom: 23px;
  right: 100px;
  background: #fff;
  &::before {
    width: 0;
    height: 0;
    border-width: 6px 0 6px 6px;
    border-style: solid;
    border-color: transparent transparent transparent #fff;
    position: absolute;
    right: -6px;
    bottom: 22px;
    content: "";
    display: block;
  }
  .main {
    margin: 25px;
  }
  .title {
    h2 {
      font: 14px/24px MicrosoftYaHei;
      color: #262626;
    }
  }
  .time {
    font: 12px/22px MicrosoftYaHei;
    color: #999;
  }
  .phone {
    font: 18px/40px MicrosoftYaHei;
    color: #4f65ae;
    .iconfont {
      font-size: 20px;
      font-weight: 600;
    }
  }
  .btn {
    width: 106px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    background-color: #4f65ae;
    border-color: #4f65ae;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-bottom: 20px;
    .iconfont {
      font-size: 20px;
    }
  }
  .qr-code {
    display: flex;
    justify-content: space-between;
    img {
      width: 90px;
      height: 90px;
      display: block;
      border: 1px solid #f0f2f5;
    }
    span {
      font: 12px/34px MicrosoftYaHei;
      color: #aaa;
      display: block;
      text-align: center;
    }
  }
}
</style> 